import stepper from "./_stepper.store";
import object from "./_object.store";
import validation from "./_validation.store";

export default {
    state: {
        ...stepper.state,
        ...object.state,
        ...validation.state,
    },
    getters: {
        ...stepper.getters,
        ...object.getters,
        ...validation.getters,
    },
    mutations: {
        ...stepper.mutations,
        ...object.mutations,
        ...validation.mutations,
    },
    actions: {
        ...stepper.actions,
        ...object.actions,
        ...validation.actions,
    },
};
